import BaseComponent from "common/Components/BaseComponent";
import Users from "./Users";
import "./Admin.styles.css";

const Admin = () => (
  <BaseComponent>
    <Users />
  </BaseComponent>
);

export default Admin;
